import About from "../Sections/home/About";
import Banner from "../Sections/home/Banner";
import Countdown from "../Sections/home/Countdown";
import Features from "../Sections/home/Features";
import Jumbotron from "../Sections/home/Jumbotron";
import Logos from "../Sections/home/Logos";
import Products from "../Sections/home/Products";
import Testimonial from "../Sections/home/Testimonial";
import LastBlog from "../Sections/home/LastBlog";
import { useGetSettingQuery } from "../../../Redux/Apis/siteApi";

function Home() {
    const { data: {home,id} } = useGetSettingQuery()

    return ( 
        <>
        {home.jumbotron && <Jumbotron/>}
        {home.features && <Features/>}
        {home.products && <Products/>}
        {home.countdown && <Countdown/>}
        {home.testimonial && <Testimonial/>}
        {home.about && <About/>}
        {home.banner && <Banner/>}
        {home.last_blog && <LastBlog name={home.last_blog.name} caption={home.last_blog.caption} site_id={id}/>}
        {home.logos && <Logos/>}
        </>
    );
}

export default Home;